import styled from 'styled-components';
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import { Flex } from '../../atoms';
export const OfferTimerContainer = styled(Flex)`
  background-color: ${props => getBackgroundColor(props.bg)(props)};
  max-width: 208px;
`;